'use client';

import { Option } from 'effect';

import type { Announcement } from '@vs-shop/engine/service/announcements/Announcement';
import { AlertMessageBase } from './AlertMessageBase';
import { useAnnouncement } from '@vs-shop/headless/announcements/useAnnouncement';

type Props = { readonly initialMessages: readonly Announcement[] };

export function AlertMessagesBaseForDesktopClient({ initialMessages }: Props) {
  const { message } = useAnnouncement('base', initialMessages);
  return Option.match(message, {
    onNone: () => null,
    onSome: (current) => <AlertMessageBase message={current} />,
  });
}
